import { Injectable } from '@angular/core';
import { SHOPIFY_APP_URL } from '@api-ui-app/src/app/lib/constants';

@Injectable()
export class ShopifyIntegrationService {
  openAppPage() {
    window.open(SHOPIFY_APP_URL, '_blank');
  }
}
